/**
 * API version constants for the WebPortal frontend.
 *
 * Mirrors backend/src/lib/version.ts. Bump in lockstep with the
 * backend when introducing a breaking change.
 */
export const API_VERSION = 'v1';
export const API_BASE = `/api/${API_VERSION}`;
